import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetDiagnosticEventsCB} from "../../ope/diagnostic/GetDiagnosticEventsCB";
import {GetDiagnosticStatusCB} from "../../ope/diagnostic/GetDiagnosticStatusCB";

@Injectable({
  providedIn: 'root'
})
export class DiagnosticOpeService extends BaseOPEService {

  public getDiagnosticEvents(cb: GetDiagnosticEventsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDiagnosticStatus(cb: GetDiagnosticStatusCB): Promise<any> {
    return this.execOPE(cb);
  }
}
